
import { GoogleOAuthProvider } from '@react-oauth/google';
import url from './api/url';
import AppRouter from './routers/AppRouter';
import "bootstrap-icons/font/bootstrap-icons.css";

function App() {

  const { clientId } = url()

  return (
    <>
      <GoogleOAuthProvider clientId={ clientId }>
        <AppRouter />
      </GoogleOAuthProvider>
    </>
  );
}

export default App;
